import React from 'react'
import Button from '@bufferapp/ui/Button'
import type { Service } from '@buffer-mono/app-shell/src/exports/Orchestrator/channelConnections/types'
import { ORCHESTRATOR_ACTIONS } from '@buffer-mono/app-shell/src/common/events/orchestratorEvents'

const RefreshButton = (args: { service: Service }): JSX.Element => {
  const { service } = args
  const onRefresh = (): void => {
    ORCHESTRATOR_ACTIONS.connectChannel({
      selectedService: service,
      cta: `engange-channelRefresh-${service}-1`,
      isRefreshingConnection: true,
    })
  }

  return <Button type="primary" label="Refresh" onClick={onRefresh} />
}

export default RefreshButton
